<template>
    <div class="DateTimePickerMonthPicker">
        <div class="DateTimePickerMonthPicker__content">
            <div @click="previousMonth()" class="DateTimePickerMonthPicker__icon">
                <i class="icon-left-open-1"></i>
            </div>
            <div class="DateTimePickerMonthPicker__title">
                {{monthTitle}}
            </div>
            <div @click="nextMonth()" class="DateTimePickerMonthPicker__icon">
                <i class="icon-right-open-1"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'DateTimePickerMonthPicker',
        computed: {
            ...mapState({
                monthTitle: s => s.dateTimePicker.monthTitle
            })
        },
        methods: {
            ...mapActions({
                nextMonth: 'dateTimePicker/nextMonth',
                previousMonth: 'dateTimePicker/previousMonth'
            })
        }
    };
</script>


<style>
    .DateTimePickerMonthPicker {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
        padding: 8px 0;
        background-color: #37474F;
        color: #f0f0f0;
        margin: 0;
        line-height: 2rem;
    }

    .DateTimePickerMonthPicker__content {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        max-width: 250px;
    }

    .DateTimePickerMonthPicker__title {
        text-align: center;
        font-size: 1.25rem;
    }

    .DateTimePickerMonthPicker__icon {
        color: #f0f0f0;
        font-size: 24px;
        background-color: transparent;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// DateTimePickerMonthPicker.vue?a6bccdce